/** @format */

import React, { useState, useEffect, useRef } from "react";
import Select from "react-select";
import { useHistory } from "react-router";
import { toast } from "react-toastify";
import AdditonalChargesService from "../../Services/AdditionalChargesService";
import { vendorService } from "../../Services/vendorService";
import SimpleReactValidator from "simple-react-validator";

export const AddCourierAdditonalCharges = () => {
  const [, setForceUpdate] = useState("");
  const validator = useRef(
    new SimpleReactValidator({
      autoForceUpdate: { forceUpdate: setForceUpdate },
    })
  );

  const history = useHistory();

  const [courierOptionlist, setCourierOptionlist] = useState();

  const [ventorType, setVentorType] = useState({ value: "", label: "" });
  const [fuelChanges, setFuelChanges] = useState();
  const [govTax, setGovTax] = useState();
  const [freightShipment, setFreightShipment] = useState();
  const [freightShipmentMin, setFreightShipmentMin] = useState();

  const [expressShipment, setExpressShipment] = useState();
  const [expressShipmentMin, setExpressShipmentMin] = useState();
  const [handlingInOut, setHandlingInOut] = useState();
  const [palletCharges, setPalletCharges] = useState();

  useEffect(() => {
    getVendorList();
  }, []);

  const getVendorList = () => {
    vendorService.getVendor().then((res) => {
      if (res.status === true) {
        let arryVendor = [];
        res.data.map((val) => {
          arryVendor.push({ value: val.vendor_name, label: val.vendor_name });
        });
        setCourierOptionlist(arryVendor);
        const initialval = res.data.filter(
          (item) => item.vendor_name === "Fedex"
        )[0];
        setVentorType({
          value: initialval.vendor_name,
          label: initialval.vendor_name,
        });
      }
    });
  };

  const submitHandler = () => {
    let postData = {
      fuel_charges: parseInt(fuelChanges),
      govt_tax: parseInt(govTax),
      peak_search_charge_express_freight_shipment: freightShipment
        ? parseInt(freightShipment)
        : 0,
      peak_search_charge_express_freight_shipment_min: freightShipmentMin
        ? parseInt(freightShipmentMin)
        : 0,
      peak_search_charge_express_shipment: expressShipment
        ? parseInt(expressShipment)
        : 0,
      peak_search_charge_express_shipment_min: expressShipmentMin
        ? parseInt(expressShipmentMin)
        : 0,
      vendor_type: ventorType && ventorType.value,
      handlingInOut :handlingInOut,
      palletCharges :palletCharges,
    };

    let validate;

    if (ventorType.label === "Ups") {
      validate =
        +validator.current.fieldValid("vendor type") &&
        validator.current.fieldValid("fuel charges") &&
        validator.current.fieldValid("Govt. taxt");
    } else {
      validate =
        +validator.current.fieldValid("vendor type") &&
        validator.current.fieldValid("fuel charges") &&
        validator.current.fieldValid("Govt. taxt") &&
        validator.current.fieldValid("express shipment") &&
        validator.current.fieldValid("express shipment min") &&
        validator.current.fieldValid("freight shipment") &&
        validator.current.fieldValid("freight shipment min") &&
        validator.current.fieldValid("handling in/out") &&
        validator.current.fieldValid("pallet charges");
    }

    if (validate) {
      AdditonalChargesService.updateCourieraddionalcharges(postData).then(
        (res) => {
          if (res.status) {
            history.push("/courier-additional-charges");
            toast.success("Additional Charges added successfully");
          } else {
            toast.error(res.message);
          }
        }
      );
    } else {
      validator.current.showMessages();
    }
  };

  return (
    <div className="row justify-content-center">
      <div className="col-lg-6">
        <div className="card">
          <div class="d-flex mb-3 align-items-center card-header">
            <h5 class="mb-0 me-auto">
              Additional Charges{" "}
              <b>
                <small className="text-muted">
                  {/* ({item.vendor_type}) */}
                </small>
              </b>
            </h5>
            {/* <button class="btn btn-info">Edit </button> */}
          </div>
          <div className="card-body">
            <div className="row">
              <div className="col-6">
                <label>Vendor Type</label>
              </div>
              <div className="col-6">
                <Select
                  styles={{
                    valueContainer: (provided) => ({
                      ...provided,
                      height: "calc(2.15rem + 2px)",
                      overflowY: "visible",
                    }),
                    control: (provider) => ({
                      ...provider,
                      width: "100%",
                      boxShadow: "0 0 0 0px #f46a6a",
                    }),
                    placeholder: (provider) => ({
                      ...provider,
                      color: "#a0b0ca",
                    }),
                  }}
                  placeholder="Search with vendor..."
                  value={ventorType}
                  onChange={(e) => setVentorType(e)}
                  options={courierOptionlist}
                />
                {validator.current.message(
                  "vendor type",
                  ventorType,
                  "required",
                  { className: "text-danger text-capitalize" }
                )}
              </div>
            </div>

            <div className="row mt-3">
              <div className="col-6">
                <label>Fuel charges</label>
              </div>
              <div className="col-6">
                <input
                  type="number"
                  className="form-control"
                  placeholder="Enter Fuel Charges"
                  //   value={item.fuel_charges}
                  name="fuel_charges"
                  onChange={(e) => setFuelChanges(e.target.value)}
                />
                {validator.current.message(
                  "fuel charges",
                  fuelChanges,
                  "required",
                  { className: "text-danger text-capitalize" }
                )}
              </div>
            </div>

            <div className="row mt-3">
              <div className="col-6">
                <label>Government Tax</label>
              </div>
              <div className="col-6">
                <input
                  type="number"
                  className="form-control"
                  placeholder="Enter Government Tax"
                  //   value={item.govt_tax}
                  name="govt_tax"
                  onChange={(e) => setGovTax(e.target.value)}
                />
                {validator.current.message("Govt. taxt", govTax, "required", {
                  className: "text-danger text-capitalize",
                })}
              </div>
            </div>

            {ventorType && ventorType.value === "Ups" ? null : (
              <>
                <div className="row mt-3">
                  <div className="col-6">
                    <label>
                      Peak Season Surcharge Express Freight Shipment Aed/kg
                    </label>
                  </div>
                  <div className="col-6">
                    <input
                      type="number"
                      className="form-control"
                      placeholder="Enter Charges"
                      //   value={
                      //     item.peak_search_charge_express_freight_shipment
                      //   }
                      name="peak_search_charge_express_freight_shipment"
                      onChange={(e) => setFreightShipment(e.target.value)}
                    />
                    {validator.current.message(
                      "freight shipment",
                      freightShipment,
                      "required",
                      { className: "text-danger text-capitalize" }
                    )}
                  </div>
                </div>

                <div className="row mt-3">
                  <div className="col-6">
                    <label>
                      Peak Season Surcharge Express Freight Shipment min Aed
                    </label>
                  </div>
                  <div className="col-6">
                    <input
                      type="number"
                      className="form-control"
                      placeholder="Enter Charges"
                      //   value={
                      //     item.peak_search_charge_express_freight_shipment_min
                      //   }
                      name="peak_search_charge_express_freight_shipment_min"
                      onChange={(e) => setFreightShipmentMin(e.target.value)}
                    />
                    {validator.current.message(
                      "freight shipment min",
                      freightShipmentMin,
                      "required",
                      { className: "text-danger text-capitalize" }
                    )}
                  </div>
                </div>

                <div className="row mt-3">
                  <div className="col-6">
                    <label>Peak Season Surcharge Express Shipment Aed/kg</label>
                  </div>
                  <div className="col-6">
                    <input
                      type="number"
                      className="form-control"
                      placeholder="Enter Charges"
                      //   value={item.peak_search_charge_express_shipment}
                      name="peak_search_charge_express_shipment"
                      onChange={(e) => setExpressShipment(e.target.value)}
                    />
                    {validator.current.message(
                      "express shipment",
                      expressShipment,
                      "required",
                      { className: "text-danger text-capitalize" }
                    )}
                  </div>
                </div>

                <div className="row mt-3">
                  <div className="col-6">
                    <label>
                      Peak Season Surcharge Express Shipment min Aed
                    </label>
                  </div>
                  <div className="col-6">
                    <input
                      type="number"
                      className="form-control"
                      placeholder="Enter Charges"
                      //   value={item.peak_search_charge_express_shipment_min}
                      name="peak_search_charge_express_shipment_min"
                      onChange={(e) => setExpressShipmentMin(e.target.value)}
                    />
                    {validator.current.message(
                      "express shipment min",
                      expressShipmentMin,
                      "required",
                      { className: "text-danger text-capitalize" }
                    )}
                  </div>
                </div>
              </>
            )}

            {ventorType && ventorType.value === "Tnt" && (
              <>
                 <div className="row mt-3">
                  <div className="col-6">
                    <label>
                    Handling In/Out
                    </label>
                  </div>
                  <div className="col-6">
                    <input
                      type="number"
                      className="form-control"
                      placeholder="Enter Charges"
                      //   value={item.peak_search_charge_express_shipment_min}
                      name="haldling_in_out"
                      onChange={(e) => setHandlingInOut(e.target.value)}
                    />
                    {validator.current.message(
                      "handling in/out",
                      handlingInOut,
                      "required",
                      { className: "text-danger text-capitalize" }
                    )}
                  </div>
                </div>
                <div className="row mt-3">
                  <div className="col-6">
                    <label>
                    Pallet Charges
                    </label>
                  </div>
                  <div className="col-6">
                    <input
                      type="number"
                      className="form-control"
                      placeholder="Enter Charges"
                      //   value={item.peak_search_charge_express_shipment_min}
                      name="pallet_charges"
                      onChange={(e) => setPalletCharges(e.target.value)}
                    />
                    {validator.current.message(
                      "pallet charges",
                      palletCharges,
                      "required",
                      { className: "text-danger text-capitalize" }
                    )}
                  </div>
                </div>
              </>
            )}

            <div className="d-flex justify-content-between">
              <button
                class="btn btn-danger w-sm waves-effect waves-light mt-3"
                onClick={() => history.goBack()}
              >
                Back
              </button>
              <button
                class="btn btn-primary ms-auto d-block mt-3"
                onClick={() => submitHandler()}
              >
                Add{" "}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
